module.exports = __webpack_public_path__ + "static/media/Playa_Bowls_Dickinson_Tour_Guides_20210816_LOH_25--resized.8968bddb.jpg";